export const PPT_STUDIO_PATH = '/ppt';

// 答辩PPT 放在最前面并作为默认用途；另外两个用途保留可选
export const SCENARIOS = [
    {
        value: 'academic_defense',
        label: '答辩PPT',
        desc: '依据已完成的研究讲方法、结果、贡献与局限，缺少的内容标注待补充',
    },
    {
        value: 'academic_proposal',
        label: '开题答辩',
        desc: '讲研究问题、拟用方法、技术路线与可行性，区分已有工作和计划',
    },
    {
        value: 'general',
        label: '通用演示',
        desc: '工作汇报、培训、营销、产品介绍等，按主题组织内容',
    },
];

export const INPUT_MODES = [
    { value: 'text', label: '输入主题或正文' },
    { value: 'file', label: '上传文档' },
];

// 与 PPT 服务、后端的限制保持一致
export const PLAIN_TEXT_MAX = 20000;
export const REQUIREMENT_MAX = 2000;
export const AUDIENCE_MAX = 200;
export const UPLOAD_MAX_MB = 30;
export const UPLOAD_ACCEPT = '.docx,.doc,.pdf,.txt';
export const UPLOAD_EXTENSIONS = ['docx', 'doc', 'pdf', 'txt'];
export const PAGE_MIN = 3;
export const PAGE_MAX = 40;
export const DURATION_MIN = 1;
export const DURATION_MAX = 180;
export const REDEEM_CODE_MAX = 64;

export const DEFAULT_SETTINGS = {
    scenario: 'academic_defense',
    audience: '',
    durationMinutes: null,
    pageCount: null,
    generateNotes: false,
};

export const STATUS = {
    MATERIAL_PROCESSING: 'MATERIAL_PROCESSING',
    MATERIAL_READY: 'MATERIAL_READY',
    MATERIAL_FAILED: 'MATERIAL_FAILED',
    AWAITING_PAYMENT: 'AWAITING_PAYMENT',
    SUBMITTING: 'SUBMITTING',
    SUBMIT_FAILED: 'SUBMIT_FAILED',
    GENERATING: 'GENERATING',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
};

export const STATUS_LABELS = {
    MATERIAL_PROCESSING: '整理资料中',
    MATERIAL_READY: '资料已就绪',
    MATERIAL_FAILED: '资料整理失败',
    AWAITING_PAYMENT: '待支付',
    SUBMITTING: '提交中',
    SUBMIT_FAILED: '提交失败',
    GENERATING: '生成中',
    COMPLETED: '已完成',
    FAILED: '生成失败',
};

export const STAGES = [
    { key: 'planning', label: '规划大纲', hint: '根据内容确定页数与叙事结构' },
    { key: 'content', label: '撰写内容', hint: '分批撰写每页文字与图表数据' },
    { key: 'rendering', label: '排版渲染', hint: '套用模板生成可编辑页面' },
    { key: 'done', label: '完成', hint: '预览并下载 PPTX / PDF' },
];

export const WORKFLOW_STEPS = [
    { label: '内容与用途', hint: '输入或上传资料' },
    { label: '选择模板', hint: '决定视觉风格' },
    { label: '生成与下载', hint: '支付后生成并导出' },
];

export const TEXT_EXAMPLES = [
    {
        label: '毕业答辩',
        text: '毕业论文题目：基于改进 YOLOv8 的校园垃圾分类识别系统。研究背景是校园垃圾分类准确率低、人工督导成本高；自建了约 3000 张图片的数据集，在 YOLOv8 基础上加入注意力模块，mAP@0.5 从 86.1% 提升到 89.4%，并部署成微信小程序。请按研究背景、相关工作、方法设计、实验结果、结论与不足组织答辩内容。',
    },
    {
        label: '开题答辩',
        text: '开题题目：基于深度学习的校园垃圾分类识别系统。研究背景是校园垃圾分类准确率低、人工督导成本高；拟采用 YOLOv8 做目标检测，计划自建约 3000 张图片的数据集。请说明研究内容、技术路线、进度安排和预期成果，并区分已完成的前期工作和后续计划。',
    },
    {
        label: '季度工作复盘',
        text: '为客户服务团队做一份季度复盘汇报：本季度处理工单 1200 张，平均首次响应时间从 6 小时降到 4 小时；主要问题是高峰期人手不足、知识库更新不及时。请说明原因分析，以及下季度的三项改进计划和验收方式。',
    },
];
